(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bikiniyes-directory-sidebar-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('by-directory-sidebar')) {
    customElements.define('by-directory-sidebar', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.frame = 0;
        this.link = this.querySelector('a');
        this.wrapper = this.closest('.m-collection--wrapper');
        this.observed = new Set();
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            if (!this.isConnected) return;
            this.observeLayout();
            this.fit();
          });
        };
        this.resizeObserver = new ResizeObserver(this.queue);
        this.mutationObserver = new MutationObserver(this.queue);
        if (this.wrapper) {
          this.mutationObserver.observe(this.wrapper, { childList: true, subtree: true });
          this.wrapper.addEventListener('load', this.queue, { capture: true, signal: this.abort.signal });
        }
        window.addEventListener('resize', this.queue, { passive: true, signal: this.abort.signal });
        this.observeLayout();
        this.queue();
      }

      observeLayout() {
        const elements = [
          this,
          this.parentElement,
          this.wrapper,
          this.wrapper?.querySelector('.m-collection-products')
        ];
        elements.forEach(element => {
          if (element && !this.observed.has(element)) {
            this.observed.add(element);
            this.resizeObserver.observe(element);
          }
        });
      }

      collapse() {
        if (this.link) this.link.hidden = true;
        if (this.style.height !== '0px') this.style.height = '0px';
      }

      fit() {
        const sidebar = this.closest('.m-sidebar');
        if (!this.link || !this.wrapper || !window.matchMedia('(min-width: 1280px)').matches ||
            !['leftColumn', 'rightColumn'].includes(sidebar?.dataset.type)) {
          this.collapse();
          return;
        }
        const cards = Array.from(this.wrapper.querySelectorAll('.m-collection-products .m-product-item'))
          .map(card => card.getBoundingClientRect())
          .filter(rect => rect.height > 0 && rect.width > 0);
        const slot = this.getBoundingClientRect();
        if (!cards.length || !slot.width) {
          this.collapse();
          return;
        }
        const lastCardBottom = Math.max(...cards.map(rect => rect.bottom));
        const gap = 18;
        const preferredHeight = Math.floor(slot.width * 2 / 3);
        const availableHeight = Math.floor(lastCardBottom - slot.top - gap - 4);
        const height = Math.min(preferredHeight, availableHeight);
        if (height < preferredHeight * .65 || height <= 0) {
          this.collapse();
          return;
        }
        const linkHeight = height + 'px';
        const slotHeight = (gap + height) + 'px';
        if (this.link.style.height !== linkHeight) this.link.style.height = linkHeight;
        if (this.style.height !== slotHeight) this.style.height = slotHeight;
        this.link.hidden = false;
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["by-article-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
    const placeShoppingCards = (scope = document) => {
      scope.querySelectorAll('[data-by-story-root]').forEach((root) => {
        const content = root.closest('.m-article__content');
        if (!content) return;
        const links = Array.from(content.querySelectorAll('a[href]')).filter((link) => !link.closest('[data-by-story-group]'));
        root.querySelectorAll('[data-by-story-group]').forEach((group) => {
          const suffix = `/${group.dataset.storyKind}/${group.dataset.storyHandle}`;
          const matchingLinks = links.filter((link) => {
            try {
              const url = new URL(link.getAttribute('href'), window.location.href);
              return url.origin === window.location.origin && url.pathname.replace(/\/$/, '').endsWith(suffix);
            } catch {
              return false;
            }
          });
          const anchor = group.dataset.storyKind === 'products'
            ? matchingLinks.find((link) => link.querySelector('img')) || matchingLinks[0]
            : matchingLinks[0];
          if (!anchor) return;
          const block = anchor.closest('p, figure, li, blockquote, h2, h3');
          if (!block || !content.contains(block) || block.closest('[data-by-story-group]')) return;
          const imageOnly = group.dataset.storyKind === 'products' && block.matches('p, figure') && block.textContent.trim() === '' && block.querySelectorAll('a').length === 1 && block.querySelectorAll('img').length === 1;
          if (imageOnly) block.replaceWith(group);
          else block.insertAdjacentElement('afterend', group);
        });
        if (!root.children.length) root.remove();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => placeShoppingCards(), { once: true });
    else placeShoppingCards();
    document.addEventListener('shopify:section:load', (event) => placeShoppingCards(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
